import { Component, OnInit, HostListener, Output, Input } from '@angular/core';
import { EventEmitter } from 'events';
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.css']
})
export class RatingComponent implements OnInit {

  rating: any;
  @Input('researchData') researchData: any;
  // @Output('ratingDataEvent') ratingDataEvent = new EventEmitter();
  @HostListener('document:keyup', ['$event']) keyups(event: KeyboardEvent): void {
    if (event.keyCode === 27) {
      this.cancel();
    }
  }

  constructor(
    private rolesSharedService: RolesSharedService
  ) { }

  ngOnInit() {

  }

  cancel() {
    this.rating = null;
  }

  mapPostData() {
    let data: any = {}
    data = {
      postId: "42bcd84e-5887-424a-a119-d5cea3af1cb8",
      rating: 4.5,
      userId: "7ecc9d31-b45b-4cc7-a50a-99a54c15977a",
      postType: "trending_research"
    }
  }

  trigerRatingComponentOutput() {
    this.rolesSharedService.rating(this.mapPostData())
  }


}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/rating/rating.component.ts